import  * as c from '../constants';


const INIT_STATE = {
  isSubmitting: false,
  isFetching: false,
  isError: false,
  errorMessage: ""
}


export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_RESET: {
      return INIT_STATE;
    }
    
    case c.HOTKEY_TMP_SET_FETCHING_STATUS: {
      return {
        ...state,
        isFetching: action.payload
      }
    }

    case c.HOTKEY_TMP_SET_SUBMITTING_STATUS: {
      return {
        ...state,
        isSubmitting: action.payload
      }
    }

    case c.HOTKEY_TMP_SET_ERROR_STATUS: {
      return {
        ...state,
        isFetching: false,
        isSubmitting: false,
        isError: true,
        errorMessage: action.payload
      }
    }
      
    default: {
      return state;
    }
  }
}
